if(window.addEventListener) {
    window.addEventListener('load', imageScrollFunc);
} else {
    window.attachEvent('onload', imageScrollFunc);
}

var useNewCarousel = true;

function imageScrollFunc() {
    if(useNewCarousel) {
        var dataSku = $('.orbit-bullets button.is-active').attr('data-sku');
        if(dataSku !== '') {
            if($('.orbit-bullets button.is-active').length > 0) {
                $('.orbit-container').css('height', $('.orbit-slide').filter('[data-sku*=' + dataSku + ']').innerHeight() + 20 + 'px');
                $('.orbit-slide').filter('[data-sku*=' + dataSku + ']').first().show();
            }
        } else {
            $('.orbit-slide').filter('[data-sku*=DefaultProductImage]').show();
        }
    }

    /* Expand width on breadcrumbs */
    $('.breadcrumbs-container .row').css('max-width', '90rem');
    var thumbContainerWidth = $('.orbit-bullets').width();
    var scrollWidth = thumbContainerWidth * '.25';

    if(!useNewCarousel) {
        $('.orbit-bullets button').show();
    }

    if($('.orbit-bullets').prop('scrollWidth') > $('.orbit-bullets').width()) {
        $('.scrollButton').show();
    }
    $('.scrollButton').css('height', $('.orbit-bullets button.is-active').height() + 2).css('bottom', ($('.orbit-bullets').height() - $('.orbit-bullets button.is-active').height() - 2 + parseInt($('.orbit-bullets').css('margin-bottom'))));
    $('.scrollButton i').css('line-height', $('.orbit-bullets button.is-active').height() + 2 + 'px');
    $('#downClick').on('click',
        function () {
            if(($('.orbit-bullets').scrollLeft() + thumbContainerWidth - scrollWidth) >=
                $('.orbit-bullets').prop('scrollWidth')) {
                $('.orbit-bullets').animate({
                    scrollLeft: $('.orbit-bullets').prop('scrollWidth')
                });
            } else {
                $('.orbit-bullets').animate({
                    scrollLeft: $('.orbit-bullets').scrollLeft() + thumbContainerWidth - scrollWidth
                });
            }
        });

    $('#upClick').on('click',
        function () {
            $('.orbit-bullets').animate({
                scrollLeft: $('.orbit-bullets').scrollLeft() - thumbContainerWidth - scrollWidth
            });
        });
    $('.orbit-bullets').scroll(function () {
        if($('.orbit-bullets').scrollLeft() + $('.orbit-bullets').width() === $('.orbit-bullets').prop('scrollWidth')) {
            $('#downClick i').addClass('scrollEnd');
        } else if($('.orbit-bullets').scrollLeft() === 0) {
            $('#upClick i').addClass('scrollEnd');
        } else {
            $('.scrollButton i').removeClass('scrollEnd');
        }
    });
    $('.orbit-bullets button').click(function () {
        if($('.orbit-bullets button.is-active').length > 0) {
            $('.orbit-container').css('height', $('.orbit-slide.is-active img.orbit-image').innerHeight() + 20 + 'px');
        }
        // $(window).scrollTop(0);
    });
    /* Set height of video iframes */
    var modalWidth = getModalWidth($('.reveal.large')).w;
    var iframeHeight = modalWidth * '.65';
    $('.reveal.large iframe').height(iframeHeight + 'px');
    $('.orbit-slide').click(function () {
        setAutoplay('reveal-' + $(this).attr('data-sku'));
    });
    $('[data-reveal]').on('closed.zf.reveal', function () {
        removeAutoplay();
    });
    $('.print-button').click(function () {
        printScreen($('.print-button').attr('printSrc'));
    });

    $('#downClickSlide').click(function () {
        if(!$('#downClickSlide').hasClass('disabled')) {
            var currentSlide = $(this).attr('data-current-slide');
            var slides = $('#hdnSlides').val().split(',');
            var indexOfSlide = slides.indexOf(currentSlide);
            if(indexOfSlide > 0) {
                var nextSlide = slides[indexOfSlide - 1];
                indexOfSlide = slides.indexOf(nextSlide);
                if(indexOfSlide === 0) {
                    $('#downClickSlide').addClass('disabled');
                    $('#upClickSlide').removeClass('disabled');
                }
                $('#upClickSlide').attr('data-current-slide', nextSlide);
                $('#downClickSlide').attr('data-current-slide', nextSlide);
                var button = $('div.orbit-bullets').find(`button[data-slide="${nextSlide}"]`);
                button.trigger('click');
            } else {
                $('#downClickSlide').addClass('disabled');
                $('#upClickSlide').removeClass('disabled');
            }
        }
    });

    $('#upClickSlide').click(function () {
        if(!$('#upClickSlide').hasClass('disabled')) {
            var currentSlide = $(this).attr('data-current-slide');
            var slides = $('#hdnSlides').val().split(',');
            var indexOfSlide = slides.indexOf(currentSlide);
            if(indexOfSlide < slides.length - 1) {
                var nextSlide = slides[indexOfSlide + 1];
                indexOfSlide = slides.indexOf(nextSlide);
                if(indexOfSlide === slides.length - 1) {
                    $('#upClickSlide').addClass('disabled');
                    $('#downClickSlide').removeClass('disabled');
                }
                $('#upClickSlide').attr('data-current-slide', nextSlide);
                $('#downClickSlide').attr('data-current-slide', nextSlide);
                var button = $('div.orbit-bullets').find(`button[data-slide="${nextSlide}"]`);
                button.trigger('click');
            } else {
                $('#upClickSlide').addClass('disabled');
                $('#downClickSlide').removeClass('disabled');
            }
        }
    });
}

function changeImage() {
    var dir = $(this).attr('data-direction');
    var $overlays;
    if(useNewCarousel) {
        var selectedFlavor = $("input:radio[name='flavor']:checked").val().split(',');
        var flavorCriteria = '';

        for (var i = 0; i < selectedFlavor.length; i++) {
            flavorCriteria = flavorCriteria + '[id*=reveal-' + selectedFlavor[i] + '],';
        }

        $overlays = $('.reveal.overlay-image.large').filter(flavorCriteria + '[shared-sku*=true]');
    } else {
        $overlays = $('.reveal.overlay-image');
    }

    var overlayIndex = $overlays.index($overlays.filter(':visible')[0]);
    var newIndex;

    if(dir === 'prev') {
        newIndex = (overlayIndex + $overlays.length - 1) % $overlays.length;
    } else {
        newIndex = (overlayIndex + $overlays.length + 1) % $overlays.length;
    }

    var $newOverlay = $overlays.eq(newIndex);
    $newOverlay.foundation('open');
    setAutoplay($newOverlay.attr('id'));
}

function getModalWidth(obj) {
    if($(obj).length === 0) {
        return false;
    }
    var clone = obj.clone();
    clone.css({
        visibility: 'hidden',
        width: '',
        height: '',
        maxWidth: '',
        maxHeight: ''
    });
    $('body').append(clone);
    var width = clone.outerWidth();
    clone.remove();
    return { w: width };
}

function setAutoplay(sku) {
    if($('.reveal-overlay #' + sku + ' iframe').length) {
        var iframeSrc = $('.reveal-overlay #' + sku + ' iframe').attr('src');
        var newIframeSrc = iframeSrc.replace('autoplay=0', 'autoplay=1');
        $('.reveal-overlay #' + sku + ' iframe').attr('src', newIframeSrc);
    }
}

function removeAutoplay() {
    $('.reveal-overlay .reveal.large iframe').each(function () {
        var iframeSrc = $(this).attr('src');
        var newIframeSrc = iframeSrc.replace('autoplay=1', 'autoplay=0');
        $(this).attr('src', newIframeSrc).attr('src', function (i, val) { return val; });
    });
}

function printScreenSource(source) {
    return '<html><head><script>function step1(){\n' +
        "setTimeout('step2()', 1000);}\n" +
        'function step2(){window.print();}\n' +
        "</script></head><body onload='step1()'>\n" +
        "<embed type = 'application/pdf' src = '" + source + "' id = 'pdfDocument' width = '100%' height = '100%'></embed></body></html>";
}

function printScreen(source) {
    var pagelink = 'about:blank';
    var pwa = window.open(pagelink, '_new');
    pwa.document.open();
    pwa.document.write(printScreenSource(source));
    pwa.document.close();
}

$(function () {
    $('.changeImage').on('click', changeImage);
});
